import type { HTMLAttributes } from "react";

export type StatusVariant = "ok" | "warn" | "info";

export interface StatusDotProps extends HTMLAttributes<HTMLSpanElement> {
  /** Sémantique :
   *  - `ok`   : vert (status conforme, livrable, hausse)
   *  - `warn` : rust chaud (alerte, échéance)
   *  - `info` : aubergine (information neutre, journal d'activité) */
  variant: StatusVariant;
  /** Libellé accessible quand le dot porte du sens (sinon décoratif). */
  label?: string;
}

/**
 * Pastille colorée 8 px avec halo doux. Accompagne typiquement un libellé
 * texte adjacent (le dot seul est purement décoratif sauf si `label` fourni).
 */
export function StatusDot({ variant, label, className = "", ...rest }: StatusDotProps) {
  const composed = ["ui-dot", `ui-dot-${variant}`, className].filter(Boolean).join(" ");
  if (label) {
    return <span className={composed} role="img" aria-label={label} {...rest} />;
  }
  return <span className={composed} aria-hidden="true" {...rest} />;
}
